/**
 * Magician rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "You have no atlas, but your spellbook may contain sites, and
 *    you start with seven cards.
 *    Tap → Play a site."
 *
 *   1. "You have no atlas" / "start with seven cards." Opening-hand
 *      modifier, belongs here. Spellbook = 7, Atlas = 0. The runtime
 *      reads `deckbuilding.forbidAtlas` to suppress the empty Atlas
 *      pile entirely at spawn time and to collapse the start-phase
 *      draw prompt to a single "Draw a card" option.
 *
 *   2. "Spellbook may contain sites." Relaxes the type-separation
 *      between Spellbook and Atlas at deck-build time
 *      (`src/utils/sorcery/deckRules.js`). At spawn, every instance
 *      is also stamped with `_spellbookBack: true` (gameState.js) so
 *      sites mixed into the spellbook render the spellbook card-back
 *      rather than leaking their type through the atlas back.
 *
 *   3. "Tap → Play a site." The rulebook default Avatar tap is
 *      `Tap → Draw a site`. Magician has no atlas to draw from, so
 *      `replacesBuiltinAvatarSite: true` suppresses the built-in
 *      entry; sites are played from hand via the standard drag
 *      pipeline, which is what "Tap → Play a site" already permits.
 */
export const MAGICIAN_RULES = {
  openingHand: {
    spellbook: 7,
    atlas: 0,
  },
  deckbuilding: {
    forbidAtlas: true,
    spellbookAllowsSites: true,
  },
  replacesBuiltinAvatarSite: true,
};
